import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  FormGroup,
  FormField,
  Radio,
  Checkbox,
  Input,
  Dropdown,
  TextArea
} from 'semantic-ui-react'

const CardByEquipmentUX = (props: any) => {
    return(
      <div
        id="CardByEquipment"
        style={{width:"100%", padding: "1rem"}}>
        <div
          id="CardTube"
          style={{backgroundColor: "rgba(214, 236, 243, 0.23)", borderRadius: "5px", padding: "1rem"}}>
          
          <div
            id="CardByEquipmentUX-div-2">
            
            <div
              id="CardByEquipmentUX-div-3"
              style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
              
              <div
                id="CardByEquipmentUX-div-5"
                style={{fontWeight: "bold", fontSize: "1.2rem"}}>
                {props.languageUX === "en" ? "Urinary Catheterization" : "Urinary Catheterization"}
              </div>
              <div
                id="CardByEquipmentUX-div-6">
                
                <Label
                  id="CardByEquipmentUX-Label-7">
                  {props.status}
                </Label>
              </div>
            </div>
            <div
              className="ui divider"
              id="CardByEquipmentUX-div-4">
              
            </div>
          </div>
          <div
            className="ui form"
            id="CardByEquipmentUX-div-8">
            
            <FormGroup
              id="CardByEquipmentUX-FormGroup-9"
              inline={true}>
              <FormField
                className="required"
                id="CardByEquipmentUX-FormField-11"
                inline={true}>
                <label
                  id="CardByEquipmentUX-label-13"
                  style={{minWidth: "150px", maxWidth: "150px"}}>
                  {props.languageUX === "en" ? "Urinary Catheterization" : "Urinary Catheterization"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-12"
                inline={true}
                width={1}>
                <Radio
                  checked={props.byEquipment?.data?.urinary}
                  id="CardByEquipmentUX-Radio-19"
                  label={props.byEquipment?.data?.urinary ? "Yes" : "No"}
                  onChange={props.handleChangeValue("byEquipment.data.urinary")}
                  toggle={true}>
                </Radio>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-20"
                inline={true}>
                <label
                  id="CardByEquipmentUX-label-21">
                  {}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardByEquipmentUX-FormGroup-10">
              <FormField
                id="CardByEquipmentUX-FormField-26"
                inline={true}>
                <label
                  id="CardByEquipmentUX-label-155"
                  style={{minWidth: "150px", maxWidth: "150px",}}>
                  
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-27"
                width={14}>
                <FormGroup
                  id="CardByEquipmentUX-FormGroup-28"
                  inline={true}>
                  <FormField
                    id="CardByEquipmentUX-FormField-32"
                    inline={true}>
                    <Checkbox
                      checked={props.byEquipment?.data?.retained_in_ward}
                      id="CardByEquipmentUX-Checkbox-34"
                      label={props.languageUX === "en" ? "Retained in ward" : "Retained in ward"}
                      onChange={props.handleChangeValue("byEquipment.data.retained_in_ward")}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-33"
                    inline={true}>
                    <label
                      id="CardByEquipmentUX-label-35">
                      
                    </label>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardByEquipmentUX-FormGroup-29"
                  inline={true}>
                  <FormField
                    id="CardByEquipmentUX-FormField-36"
                    inline={true}>
                    <Checkbox
                      checked={props.byEquipment?.data?.change_in_or}
                      id="CardByEquipmentUX-Checkbox-42"
                      label={props.languageUX === "en" ? "Change in OR" : "Change in OR"}
                      onChange={props.handleChangeValue("byEquipment.data.change_in_or")}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-37"
                    inline={true}>
                    <label
                      id="CardByEquipmentUX-label-45">
                      
                    </label>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardByEquipmentUX-FormGroup-30"
                  inline={true}>
                  <FormField
                    id="CardByEquipmentUX-FormField-38"
                    inline={true}>
                    <Checkbox
                      checked={props.byEquipment?.data?.is_intermittent_cath}
                      id="CardByEquipmentUX-Checkbox-43"
                      label={props.languageUX === "en" ? "Intermittent Cath" : "Intermittent Cath"}
                      onChange={props.handleChangeValue("byEquipment.data.is_intermittent_cath")}
                      style={{minWidth: "135px", maxWidth: "135px"}}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-48"
                    inline={true}
                    width={2}>
                    <Input
                      disabled={props.byEquipment?.data?.is_intermittent_cath ? false : true}
                      id="CardByEquipmentUX-Input-50"
                      onChange={props.handleChangeValue("byEquipment.data.intermittent_cath")}
                      value={props.byEquipment?.data?.intermittent_cath}>
                    </Input>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-49">
                    <label
                      id="CardByEquipmentUX-label-51">
                      {props.languageUX === "en" ? "ml" : "ml"}
                    </label>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardByEquipmentUX-FormGroup-31"
                  inline={true}>
                  <FormField
                    id="CardByEquipmentUX-FormField-40"
                    inline={true}>
                    <Checkbox
                      checked={props.byEquipment?.data?.insertOR}
                      id="CardByEquipmentUX-Checkbox-44"
                      label={props.languageUX === "en" ? "Insert in OR" : "Insert in OR"}
                      onChange={props.handleChangeValue("byEquipment.data.insertOR")}
                      style={{minWidth: "135px", maxWidth: "135px"}}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-52"
                    inline={true}
                    width={2}>
                    <Input
                      disabled={props.byEquipment?.data?.insertOR ? false : true}
                      id="CardByEquipmentUX-Input-54"
                      onChange={props.handleChangeValue("byEquipment.data.insert_in_or")}
                      value={props.byEquipment?.data?.insert_in_or}>
                    </Input>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-53"
                    inline={true}>
                    <label
                      id="CardByEquipmentUX-label-55">
                      
                    </label>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardByEquipmentUX-FormGroup-178"
                  inline={true}>
                  <FormField
                    id="CardByEquipmentUX-FormField-179"
                    inline={true}>
                    <Checkbox
                      checked={props.byEquipment?.data?.is_foley_cath_size}
                      disabled={props.byEquipment?.data?.insertOR ? false : true}
                      id="CardByEquipmentUX-Checkbox-180"
                      onChange={props.handleChangeValue("byEquipment.data.is_foley_cath_size")}
                      style={{marginTop: "8px"}}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-57"
                    inline={true}
                    width={5}>
                    <label
                      id="CardByEquipmentUX-label-156"
                      style={{width: "100%", maxWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Foley Cath Size (Fr)" : "Foley Cath Size (Fr)"}
                    </label>
                    <Dropdown
                      clearable={true}
                      disabled={props.byEquipment?.data?.insertOR ? false : true}
                      fluid={true}
                      id="CardByEquipmentUX-Dropdown-62"
                      onChange={props.handleChangeValue("byEquipment.data.foley_cath_size")}
                      options={props.masterOptions?.orFoleyCathSize}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.byEquipment?.data?.foley_cath_size}>
                    </Dropdown>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-59"
                    inline={true}
                    width={6}>
                    <label
                      id="CardByEquipmentUX-label-157"
                      style={{width: "100%", maxWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Catheterize Solution" : "Catheterize Solution"}
                    </label>
                    <Dropdown
                      clearable={true}
                      disabled={props.byEquipment?.data?.insertOR ? false : true}
                      fluid={true}
                      id="CardByEquipmentUX-Dropdown-63"
                      onChange={props.handleChangeValue("byEquipment.data.catheterize_solution")}
                      options={props.masterOptions?.orClinicalTerm}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.byEquipment?.data?.catheterize_solution}>
                    </Dropdown>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-171">
                    <label
                      id="CardByEquipmentUX-label-172"
                      style={{width: "100%", maxWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Ordered/ Inserted by " : "Ordered/ Inserted by "}
                    </label>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-166"
                    inline={true}
                    width={3}>
                    <div
                      id="CardByEquipmentUX-div-169"
                      style={{ width: "100%" }}>
                      {props.foleyCathNurseSearchBox}
                    </div>
                  </FormField>
                </FormGroup>
                <FormGroup
                  id="CardByEquipmentUX-FormGroup-164"
                  inline={true}>
                  <FormField
                    id="CardByEquipmentUX-FormField-181"
                    inline={true}>
                    <Checkbox
                      checked={props.byEquipment?.data?.is_ng_tube_size}
                      disabled={props.byEquipment?.data?.insertOR ? false : true}
                      id="CardByEquipmentUX-Checkbox-185"
                      onChange={props.handleChangeValue("byEquipment.data.is_ng_tube_size")}
                      style={{marginTop: "8px"}}>
                    </Checkbox>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-182"
                    inline={true}
                    width={5}>
                    <label
                      id="CardByEquipmentUX-label-186"
                      style={{width: "100%", maxWidth: "max-content"}}>
                      {props.languageUX === "en" ? "NG Tube Size" : "NG Tube Size"}
                    </label>
                    <Dropdown
                      allowAdditions={true}
                      clearable={true}
                      disabled={props.byEquipment?.data?.insertOR ? false : true}
                      fluid={true}
                      id="CardByEquipmentUX-Dropdown-187"
                      onAddItem={props.onAddNgTubeSize}
                      onChange={props.handleChangeValue("byEquipment.data.ng_tube_size")}
                      options={props.masterOptions?.orNgTubeSize}
                      selection={true}
                      style={{width: "100%"}}
                      value={props.byEquipment?.data?.ng_tube_size}>
                    </Dropdown>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-183"
                    inline={true}>
                    <label
                      id="CardByEquipmentUX-label-188"
                      style={{width: "100%", maxWidth: "max-content"}}>
                      {props.languageUX === "en" ? "Ordered/ Inserted by " : "Ordered/ Inserted by "}
                    </label>
                  </FormField>
                  <FormField
                    id="CardByEquipmentUX-FormField-184"
                    inline={true}
                    width={3}>
                    <div
                      id="CardByEquipmentUX-div-189"
                      style={{ width: "100%" }}>
                      {props.ngTubeNurseSearchBox}
                    </div>
                  </FormField>
                </FormGroup>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardByEquipmentUX-div-140"
            style={{display: "flex", justifyContent: "flex-end"}}>
            
            <div
              id="CardByEquipmentUX-div-141">
              {props.buttonSave}
            </div>
            <div
              id="CardByEquipmentUX-div-142"
              style={{margin: "0px 10px"}}>
              {props.buttonConfirm}
            </div>
            <div
              id="CardByEquipmentUX-div-143">
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
        <div
          id="CardByEquipmentUX-div-64"
          style={{backgroundColor: "rgba(214, 236, 243, 0.23)", borderRadius: "5px", padding: "1rem", marginTop: "1rem"}}>
          
          <div
            id="CardByEquipmentUX-div-65">
            
            <div
              id="CardByEquipmentUX-div-66"
              style={{display: "flex"}}>
              
              <div
                id="CardByEquipmentUX-div-68"
                style={{fontWeight: "bold", fontSize: "1.2rem", marginRight: "20px"}}>
                {props.languageUX === "en" ? "Implant" : "Implant"}
              </div>
              <div
                id="CardByEquipmentUX-div-69"
                style={{display: "flex", alignItems: "center"}}>
                
                <Radio
                  checked={props.PerioperativeNursingSequence?.implantData?.is_active}
                  id="CardByEquipmentUX-Radio-86"
                  onChange={props.handleChangeValue("implantData.is_active")}
                  toggle={true}>
                </Radio>
                <label
                  id="CardByEquipmentUX-label-85"
                  style={{marginLeft: "20px", fontWeight: "bold"}}>
                  {props.PerioperativeNursingSequence?.implantData?.is_active ? "Yes" : "No"}
                </label>
              </div>
            </div>
            <div
              className="ui divider"
              id="CardByEquipmentUX-div-67">
              
            </div>
          </div>
          <div
            className="ui form"
            id="CardByEquipmentUX-div-70">
            
            <FormGroup
              id="CardByEquipmentUX-FormGroup-71"
              inline={true}
              style={{display: "none"}}>
              <FormField
                id="CardByEquipmentUX-FormField-81"
                inline={true}
                style={{minWidth: "max-content"}}
                width={1}>
                <label
                  id="CardByEquipmentUX-label-84">
                  {props.languageUX === "en" ? "Implant" : "การปลูกถ่าย"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-82"
                inline={true}
                width={1}>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-83"
                inline={true}>
              </FormField>
            </FormGroup>
            <div
              id="CardByEquipmentUX-div-160"
              style={{width: "100%"}}>
              
              <div
                id="CardByEquipmentUX-div-159">
                {props.ImplantAdd}
              </div>
            </div>
            <FormGroup
              id="CardByEquipmentUX-FormGroup-72"
              inline={true}
              style={{display: "none"}}>
              <FormField
                id="CardByEquipmentUX-FormField-87"
                inline={true}
                width={1}>
                <label
                  id="CardByEquipmentUX-label-89">
                  {props.languageUX === "en" ? "Type" : "พิมพ์"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-88"
                inline={true}
                width={10}>
                <Input
                  disabled={props.PerioperativeNursingSequence?.implantData?.is_active ? false : true}
                  id="CardByEquipmentUX-Input-90"
                  onChange={props.handleChangeValue("implantData.type")}
                  value={props.PerioperativeNursingSequence?.implantData?.type}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardByEquipmentUX-FormGroup-91">
              <div
                id="CardByEquipmentUX-div-95"
                style={{width: "100%"}}>
                {props.ImplantImage}
              </div>
            </FormGroup>
            <FormGroup
              id="CardByEquipmentUX-FormGroup-92"
              inline={true}
              style={{display: "flex"}}>
              <FormField
                id="CardByEquipmentUX-FormField-93"
                inline={true}
                style={{justifyContent: "flex-end"}}
                width={15}>
                <div
                  id="CardByEquipmentUX-div-161"
                  style={props.PerioperativeNursingSequence?.implantData?.saved === "" ? {display: "none"} : {}}>
                  
                  <label
                    id="CardByEquipmentUX-label-162"
                    style={{fontWeight: "bold"}}>
                    {props.languageUX === "en" ? "Lasted recorded by" : "Lasted recorded by"}
                  </label>
                  <label
                    id="CardByEquipmentUX-label-163"
                    style={{marginLeft: "10px"}}>
                    {props.PerioperativeNursingSequence?.implantData?.saved}
                  </label>
                </div>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-94"
                inline={true}>
                <div
                  id="CardByEquipmentUX-div-154">
                  {props.buttonSaveImplant}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardByEquipmentUX-div-97"
          style={{backgroundColor: "rgba(214, 236, 243, 0.23)", borderRadius: "5px", padding: "1rem", marginTop: "1rem"}}>
          
          <div
            id="CardByEquipmentUX-div-98">
            
            <div
              id="CardByEquipmentUX-div-100"
              style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
              
              <div
                id="CardByEquipmentUX-div-102"
                style={{fontWeight: "bold", fontSize: "1.2rem"}}>
                {props.languageUX === "en" ? "Drain" : "Drain"}
              </div>
              <div
                id="CardByEquipmentUX-div-103">
                
                <Label
                  id="CardByEquipmentUX-Label-145">
                  {props.statusDrain}
                </Label>
              </div>
            </div>
            <div
              className="ui divider"
              id="CardByEquipmentUX-div-101">
              
            </div>
          </div>
          <div
            className="ui form"
            id="CardByEquipmentUX-div-99">
            
            <FormGroup
              id="CardByEquipmentUX-FormGroup-104"
              inline={true}>
              <FormField
                id="CardByEquipmentUX-FormField-105"
                inline={true}
                style={{minWidth: "max-content"}}
                width={1}>
                <label
                  id="CardByEquipmentUX-label-109">
                  {props.languageUX === "en" ? "Drain" : "Drain"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-106"
                inline={true}
                width={1}>
                <Radio
                  checked={props.PerioperativeNursingSequence?.drainData?.data?.is_drain }
                  id="CardByEquipmentUX-Radio-111"
                  onChange={props.handleChangeValue("drainData.data.is_drain")}
                  toggle={true}>
                </Radio>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-107"
                inline={true}>
                <label
                  id="CardByEquipmentUX-label-110">
                  {props.PerioperativeNursingSequence?.drainData?.data?.is_drain ? "Yes" : "No"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-108"
                inline={true}
                width={10}>
                <Dropdown
                  disabled={props.PerioperativeNursingSequence?.drainData?.data?.is_drain ? false : true}
                  id="CardByEquipmentUX-Dropdown-112"
                  multiple={true}
                  onChange={props.handleChangeValue("drainData.data.drain_items")}
                  options={props.masterOptions?.orDrain}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.PerioperativeNursingSequence?.drainData?.data?.drain_items}>
                </Dropdown>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardByEquipmentUX-FormGroup-173"
              inline={true}
              style={{ display: "flex", alignItems: "baseline" }}>
              <FormField
                id="CardByEquipmentUX-FormField-174"
                inline={true}
                width={1}>
                <label
                  id="CardByEquipmentUX-label-176">
                  {props.languageUX === "en" ? "Drain Detail" : "Drain Detail"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-175"
                inline={true}
                width={11}>
                <TextArea
                  id="CardByEquipmentUX-TextArea-177"
                  onChange={props.handleChangeValue("drainData.data.drain_detail")}
                  value={props.PerioperativeNursingSequence?.drainData?.data?.drain_detail}>
                </TextArea>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardByEquipmentUX-div-146"
            style={{display: "flex", justifyContent: "flex-end"}}>
            
            <div
              id="CardByEquipmentUX-div-148">
              {props.buttonSaveDrain}
            </div>
            <div
              id="CardByEquipmentUX-div-149"
              style={{ margin: "0px 10px" }}>
              {props.buttonConfirmDrain}
            </div>
            <div
              id="CardByEquipmentUX-div-150">
              {props.buttonUnconfirmDrain}
            </div>
          </div>
        </div>
        <div
          id="CardByEquipmentUX-div-117"
          style={{backgroundColor: "rgba(214, 236, 243, 0.23)", borderRadius: "5px", padding: "1rem", marginTop: "1rem"}}>
          
          <div
            id="CardByEquipmentUX-div-118">
            
            <div
              id="CardByEquipmentUX-div-120"
              style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
              
              <div
                id="CardByEquipmentUX-div-122"
                style={{fontWeight: "bold", fontSize: "1.2rem"}}>
                {props.languageUX === "en" ? "Dressing" : "Dressing"}
              </div>
              <div
                id="CardByEquipmentUX-div-123">
                
                <Label
                  id="CardByEquipmentUX-Label-144">
                  {props.statusDressing}
                </Label>
              </div>
            </div>
            <div
              className="ui divider"
              id="CardByEquipmentUX-div-121">
              
            </div>
          </div>
          <div
            className="ui form"
            id="CardByEquipmentUX-div-119">
            
            <FormGroup
              id="CardByEquipmentUX-FormGroup-124"
              inline={true}>
              <FormField
                id="CardByEquipmentUX-FormField-129"
                inline={true}
                style={{minWidth: "max-content"}}
                width={1}>
                <label
                  id="CardByEquipmentUX-label-133">
                  {props.languageUX === "en" ? "Dressing" : "Dressing"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-130"
                inline={true}
                width={1}>
                <Radio
                  checked={props.PerioperativeNursingSequence?.dressingData?.data?.is_dressing}
                  id="CardByEquipmentUX-Radio-135"
                  onChange={props.handleChangeValue("dressingData.data.is_dressing")}
                  toggle={true}>
                </Radio>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-131"
                inline={true}>
                <label
                  id="CardByEquipmentUX-label-134">
                  {props.PerioperativeNursingSequence?.dressingData?.data?.is_dressing ? "Yes" : "No"}
                </label>
              </FormField>
              <FormField
                id="CardByEquipmentUX-FormField-132"
                inline={true}
                width={10}>
                <Dropdown
                  disabled={props.PerioperativeNursingSequence?.dressingData?.data?.is_dressing ? false : true}
                  id="CardByEquipmentUX-Dropdown-136"
                  multiple={true}
                  onChange={props.handleChangeValue("dressingData.data.dressing_items")}
                  options={props.masterOptions?.orDressing}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.PerioperativeNursingSequence?.dressingData?.data?.dressing_items}>
                </Dropdown>
              </FormField>
            </FormGroup>
          </div>
          <div
            id="CardByEquipmentUX-div-147"
            style={{display: "flex", justifyContent: "flex-end"}}>
            
            <div
              id="CardByEquipmentUX-div-151">
              {props.buttonSaveDressing}
            </div>
            <div
              id="CardByEquipmentUX-div-152"
              style={{ margin: "0px 10px" }}>
              {props.buttonConfirmDressing}
            </div>
            <div
              id="CardByEquipmentUX-div-153">
              {props.buttonUnconfirmDressing}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardByEquipmentUX

export const screenPropsDefault = {}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipment"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTube"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(214, 236, 243, 0.23)\", borderRadius: \"5px\", padding: \"1rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-2"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "Urinary Catheterization",
          "valueEN": "Urinary Catheterization"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Label",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "color": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Label-7"
        },
        "name": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-8"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormGroup",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 9,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "Urinary Catheterization",
          "valueEN": "Urinary Catheterization"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-13"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"150px\", maxWidth: \"150px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Radio",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.urinary"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Radio-19"
        },
        "label": {
          "type": "code",
          "value": "props.byEquipment?.data?.urinary ? \"Yes\" : \"No\""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.urinary\")"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-27"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-30"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "FormField",
      "parent": 28,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-33"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Checkbox",
      "parent": 32,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.retained_in_ward"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Checkbox-34"
        },
        "label": {
          "type": "value",
          "value": "Retained in ward",
          "valueEN": "Retained in ward"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.retained_in_ward\")"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-36"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 29,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-38"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-40"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Checkbox",
      "parent": 36,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.change_in_or"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Checkbox-42"
        },
        "label": {
          "type": "value",
          "value": "Change in OR",
          "valueEN": "Change in OR"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.change_in_or\")"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Checkbox",
      "parent": 38,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.is_intermittent_cath"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Checkbox-43"
        },
        "label": {
          "type": "value",
          "value": "Intermittent Cath",
          "valueEN": "Intermittent Cath"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.is_intermittent_cath\")"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"135px\", maxWidth: \"135px\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "Checkbox",
      "parent": 40,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Checkbox-44"
        },
        "label": {
          "type": "value",
          "value": "Insert in OR",
          "valueEN": "Insert in OR"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.insertOR\")"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"135px\", maxWidth: \"135px\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Input",
      "parent": 48,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.is_intermittent_cath ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Input-50"
        },
        "min": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.intermittent_cath\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.byEquipment?.data?.intermittent_cath"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "ml",
          "valueEN": "ml"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Input",
      "parent": 52,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Input-54"
        },
        "min": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.insert_in_or\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.byEquipment?.data?.insert_in_or"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Dropdown",
      "parent": 57,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Dropdown-62"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.foley_cath_size\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orFoleyCathSize"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.byEquipment?.data?.foley_cath_size"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Dropdown",
      "parent": 59,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Dropdown-63"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.catheterize_solution\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orClinicalTerm"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.byEquipment?.data?.catheterize_solution"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(214, 236, 243, 0.23)\", borderRadius: \"5px\", padding: \"1rem\", marginTop: \"1rem\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-65"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 65,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-67"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": "Implant",
          "valueEN": "Implant"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", marginRight: \"20px\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormGroup",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-71"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "FormGroup",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-72"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "label",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "การปลูกถ่าย",
          "valueEN": "Implant"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-84"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.implantData?.is_active ? \"Yes\" : \"No\""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-85"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\", fontWeight: \"bold\"}"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Radio",
      "parent": 69,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.implantData?.is_active"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Radio-86"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"implantData.is_active\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormField",
      "parent": 72,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 72,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "label",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์",
          "valueEN": "Type"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-89"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Input",
      "parent": 88,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.implantData?.is_active ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Input-90"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"implantData.type\")"
        },
        "value": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.implantData?.type"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormGroup",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-91"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormGroup",
      "parent": 70,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{justifyContent: \"flex-end\"}"
        },
        "width": {
          "type": "code",
          "value": "15"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "FormField",
      "parent": 92,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-94"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ImplantImage"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(214, 236, 243, 0.23)\", borderRadius: \"5px\", padding: \"1rem\", marginTop: \"1rem\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-99"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-101"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "Drain",
          "valueEN": "Drain"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 103,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-103"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormGroup",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-104"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-107"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": "Drain",
          "valueEN": "Drain"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-109"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "label",
      "parent": 107,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.drainData?.data?.is_drain ? \"Yes\" : \"No\""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-110"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Radio",
      "parent": 106,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.drainData?.data?.is_drain "
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Radio-111"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"drainData.data.is_drain\")"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "Dropdown",
      "parent": 108,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.drainData?.data?.is_drain ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Dropdown-112"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"drainData.data.drain_items\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orDrain"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.drainData?.data?.drain_items"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-117"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"rgba(214, 236, 243, 0.23)\", borderRadius: \"5px\", padding: \"1rem\", marginTop: \"1rem\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-118"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-119"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-121"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": "Dressing",
          "valueEN": "Dressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 120,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-123"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormGroup",
      "parent": 119,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-124"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "FormField",
      "parent": 124,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-129"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "FormField",
      "parent": 124,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-130"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 131,
      "name": "FormField",
      "parent": 124,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-131"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 132,
      "name": "FormField",
      "parent": 124,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-132"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "label",
      "parent": 129,
      "props": {
        "children": {
          "type": "value",
          "value": "Dressing",
          "valueEN": "Dressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-133"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "label",
      "parent": 131,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.dressingData?.data?.is_dressing ? \"Yes\" : \"No\""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-134"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Radio",
      "parent": 130,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.dressingData?.data?.is_dressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Radio-135"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"dressingData.data.is_dressing\")"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "Dropdown",
      "parent": 132,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.dressingData?.data?.is_dressing ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Dropdown-136"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"dressingData.data.dressing_items\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orDressing"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.dressingData?.data?.dressing_items"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-141"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0px 10px\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 140,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-143"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Label",
      "parent": 123,
      "props": {
        "children": {
          "type": "code",
          "value": "props.statusDressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Label-144"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 145,
      "name": "Label",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.statusDrain"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Label-145"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 117,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-147"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveDrain"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-148"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirmDrain"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-149"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirmDrain"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-150"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 147,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveDressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-151"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 147,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirmDressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-152"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 147,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirmDressing"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-153"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 94,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveImplant"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-154"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-155"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"150px\", maxWidth: \"150px\",}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "Foley Cath Size (Fr)",
          "valueEN": "Foley Cath Size (Fr)"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-156"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 157,
      "name": "label",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "Catheterize Solution",
          "valueEN": "Catheterize Solution"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-157"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "div",
      "parent": 160,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ImplantAdd"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-159"
        }
      },
      "seq": 159,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-160"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.implantData?.saved === \"\" ? {display: \"none\"} : {}"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "Lasted recorded by",
          "valueEN": "Lasted recorded by"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-162"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.implantData?.saved"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-163"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"10px\"}"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 164,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-164"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "FormField",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-166"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 166,
      "props": {
        "children": {
          "type": "code",
          "value": "props.foleyCathNurseSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "FormField",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-171"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 171,
      "props": {
        "children": {
          "type": "value",
          "value": "Ordered/ Inserted by ",
          "valueEN": "Ordered/ Inserted by "
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-172"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "FormGroup",
      "parent": 99,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-173"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"baseline\" }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "FormField",
      "parent": 173,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-174"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 175,
      "name": "FormField",
      "parent": 173,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-175"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "11"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "label",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": "Drain Detail",
          "valueEN": "Drain Detail"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-176"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 177,
      "name": "TextArea",
      "parent": 175,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-TextArea-177"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"drainData.data.drain_detail\")"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.PerioperativeNursingSequence?.drainData?.data?.drain_detail"
        }
      },
      "seq": 177,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "FormGroup",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormGroup-178"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 179,
      "name": "FormField",
      "parent": 178,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-179"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 180,
      "name": "Checkbox",
      "parent": 179,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.is_foley_cath_size"
        },
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Checkbox-180"
        },
        "label": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.is_foley_cath_size\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"8px\"}"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 181,
      "name": "FormField",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-181"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "FormField",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-182"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 183,
      "name": "FormField",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-183"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 184,
      "name": "FormField",
      "parent": 164,
      "props": {
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-FormField-184"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 185,
      "name": "Checkbox",
      "parent": 181,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.byEquipment?.data?.is_ng_tube_size"
        },
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR ? false : true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Checkbox-185"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.is_ng_tube_size\")"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"8px\"}"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 186,
      "name": "label",
      "parent": 182,
      "props": {
        "children": {
          "type": "value",
          "value": "NG Tube Size",
          "valueEN": "NG Tube Size"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-186"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 187,
      "name": "Dropdown",
      "parent": 182,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.byEquipment?.data?.insertOR ? false : true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-Dropdown-187"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddNgTubeSize"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"byEquipment.data.ng_tube_size\")"
        },
        "options": {
          "type": "code",
          "value": "props.masterOptions?.orNgTubeSize"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.byEquipment?.data?.ng_tube_size"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "label",
      "parent": 183,
      "props": {
        "children": {
          "type": "value",
          "value": "Ordered/ Inserted by ",
          "valueEN": "Ordered/ Inserted by "
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-label-188"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 184,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ngTubeNurseSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardByEquipmentUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" }"
        }
      },
      "seq": 189,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardByEquipmentUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
